import React from "react";
import { Avatar, Box, Chip } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const ChipTonalSize = () => {
  const handleClick = () => {
    console.log("On Click");
  };
  const handleDelete = () => {
    console.log("On Delete");
  };
  return (
    <Box sx={{ mb: 2 }}>
      <PreviewAndEditor
        title={"Basic Tonal Chip Size"}
        language={"js"}
        value={
          "        <Chip\n" +
          "          avatar={<Avatar>H</Avatar>}\n" +
          '          variant="tonal"\n' +
          '          size="medium"\n' +
          '          label="Chip Medium"\n' +
          "          onDelete={handleDelete}\n" +
          "          onClick={handleClick}\n" +
          "        />\n" +
          "        <Chip\n" +
          "          avatar={<Avatar>H</Avatar>}\n" +
          '          size="small"\n' +
          '          label="Chip Small"\n' +
          "          onDelete={handleDelete}\n" +
          "          onClick={handleClick}\n" +
          "        />\n" +
          "        <Chip\n" +
          "          avatar={<Avatar>H</Avatar>}\n" +
          '          size="xSmall"\n' +
          '          label="Chip xSmall"\n' +
          "          onDelete={handleDelete}\n" +
          "          onClick={handleClick}\n" +
          "        />"
        }
      >
        <Chip
          avatar={<Avatar>H</Avatar>}
          variant="tonal"
          size="medium"
          label="Chip Medium"
          onDelete={handleDelete}
          onClick={handleClick}
        />
        <Chip
          avatar={<Avatar>H</Avatar>}
          size="small"
          label="Chip Small"
          onDelete={handleDelete}
          onClick={handleClick}
        />
        <Chip
          avatar={<Avatar>H</Avatar>}
          size="xSmall"
          label="Chip xSmall"
          onDelete={handleDelete}
          onClick={handleClick}
        />
      </PreviewAndEditor>
    </Box>
  );
};

export default ChipTonalSize;
